// extracted by mini-css-extract-plugin
export var activityContainer = "_kr-0";
export var typingIndicatorContainer = "_kr-1";
export var typingIndicatorDot = "_kr-2";
export var wave = "_kr-3";